<script setup lang="ts">
import { usePaneStore } from '#layers/workspace/stores/pane';
import WorkspaceChromeSidebarToggle from './WorkspaceChromeSidebarToggle.vue';
import WorkspaceSwitcher from './WorkspaceSwitcher.vue';

const paneStore = usePaneStore();
</script>

<template>
	<div class="flex items-center gap-3 pe-3 text-sm font-semibold block-(--primary-header-height)">
		<WorkspaceSwitcher class="ms-3" />

		<WorkspaceChromeSidebarToggle v-if="paneStore.sidebarVisible" class="ms-auto shrink-0" />
	</div>
</template>
